import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showDialog, showErrorDialog, showSuccessDialog } from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  addMenu,
  fetchMenu,
  fetchMenuModal,
  selectData,
  selectDataMenuModal,
} from "./menuSlice";

// MUI
import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const MenuCreate = ({ isOpen, handleShow, handleClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectDataMenuModal);

  const [parent, setParent] = useState("0");
  const [menuName, setMenuName] = useState("");
  const [menuTitle, setMenuTitle] = useState("");
  const [menuUrl, setMenuUrl] = useState("");
  const [menuIcon, setMenuIcon] = useState("");
  const [position, setPosition] = useState("");

  const handleSave = async () => {
    //Validasi
    // if (menuName === "") {
    //   return showErrorDialog("Please Input Menu Name");
    // }
    // if (menuTitle === "") {
    //   return showErrorDialog("Please Input Menu Title");
    // }
    // if (menuUrl === "") {
    //   return showErrorDialog("Please Input Menu Url");
    // }
    // if (position === "") {
    //   return showErrorDialog("Please Input Menu Position");
    // }

    const mapping = Object.keys(state)
      .filter((key) => state[key])
      .map((key) => key);

    const params = {
      pid: parent,
      menu_name: menuName,
      menu_title: menuTitle,
      menu_url: menuUrl,
      menu_icon: menuIcon,
      menu_position: position,
      permissions: mapping,
    };

    try {
      const response = await dispatch(addMenu(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        await window.location.reload();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleParentChange = (e) => {
    if (e === null) {
      e = undefined;
      setParent("0");
    } else {
      setParent(e.value);
    }
  };

  const parentOptions = data.map((e) => {
    return {
      value: e.menu_id,
      label: e.menu_title + `${e.menu_mobile === "Y" ? "- Mobile" : ""}`,
    };
  });

  const getValueParent = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const [state, setState] = React.useState({
    CANCEL: true,
    CREATE: true,
    DELETE: true,
    READ: true,
    UPDATE: true,
  });

  const handleChange = (name) => (event) => {
    setState({ ...state, [name]: event.target.checked });
  };

  const { CANCEL, CREATE, DELETE, READ, UPDATE } = state;

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isOpen}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter text-white">
          New User
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12} sm={3} md={6} lg={6}>
            <Select
              isClearable={true}
              options={parentOptions}
              value={getValueParent(parent, parentOptions)}
              placeholder="Select parent"
              onChange={handleParentChange}
              className="ml-3 mb-2"
            />
            <RedditTextField
              label="Name"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              onChange={(e) => {
                setMenuName(e.target.value);
              }}
              value={menuName}
            />
            <RedditTextField
              label="Title"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              onChange={(e) => {
                setMenuTitle(e.target.value);
              }}
              value={menuTitle}
            />
            <RedditTextField
              label="URL"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              onChange={(e) => {
                setMenuUrl(e.target.value);
              }}
              value={menuUrl}
            />
            <RedditTextField
              label="Icon"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              onChange={(e) => {
                setMenuIcon(e.target.value);
              }}
              value={menuIcon}
            />
            <RedditTextField
              label="Posision"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              onChange={(e) => {
                setPosition(e.target.value);
              }}
              value={position}
            />
          </Col>
          <Col xs={12} sm={3} md={6} lg={6}>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel component="legend">Permision Default</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={CREATE}
                      onChange={handleChange("CREATE")}
                      value="CREATE"
                    />
                  }
                  label="CREATE"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={READ}
                      onChange={handleChange("READ")}
                      value="READ"
                    />
                  }
                  label="READ"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={UPDATE}
                      onChange={handleChange("UPDATE")}
                      value="UPDATE"
                    />
                  }
                  label="UPDATE"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={DELETE}
                      onChange={handleChange("DELETE")}
                      value="DELETE"
                    />
                  }
                  label="DELETE"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={CANCEL}
                      onChange={handleChange("CANCEL")}
                      value="CANCEL"
                    />
                  }
                  label="CANCEL"
                />
              </FormGroup>
            </FormControl>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
